import cn from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import styles from './index.module.scss';

export interface InputProps {
  prefix?: any;
  suffix?: any;
  type?: string;
  label?: string;
  value?: string;
  autoFocus?: boolean;
  max?: string;
  maxLength?: number;
  hasError?: boolean;
  errType?: string;
  id?: string;
  outerClass?: string;
  inputClass?: string;
  onChange?: any;
  onBlur?: (value?) => void;
  onFocus?: (value?) => void;
  onPressEnter?: any;
  placeholder?: string;
  formStyle?: string;
}

export default function StudentEmailForm(props: InputProps) {
  const { hasError = false, id = '', outerClass, inputClass, formStyle } = props;
  const isLightForm = formStyle === 'light';
  const inputEl = useRef(null);
  const [isFocus, setIsFocus] = useState(false);

  const outerStyles = twMerge(
    'relative overflow-hidden flex w-full h-[52px] box-border border-solid border-[2px] border-[#fff]',
    isLightForm && 'border-tint-black-100',
    isFocus && 'border-primary-2',
    isLightForm && isFocus && 'border-input-100-hairline-active',
    hasError && 'border-input-200-hairline-critical',
    outerClass
  );

  const labelStyles = twMerge(
    cn(
      'absolute left-0 top-0 origin-top-left translate-x-4 translate-y-4 ease-in-out duration-200 enki-body-sm-medium text-surface-200-fg-minor',
      {
        'translate-y-2 scale-[.7]': isFocus || !!props.value,
        'text-input-200-fg-critical': hasError
      }
    )
  );

  const inputStyles = twMerge(
    'border-none outline-none w-full h-full box-border px-4 pt-[18px] bg-[#EEF2FB] enki-body-sm-medium text-input-200-fg-default placeholder:!text-[#52667D] placeholder:!text-sm',
    isLightForm && 'bg-input-100-bg-default',
    isFocus && `bg-surface-100-bg ${styles.focused}`,
    hasError && `bg-input-200-bg-critical ${styles.errored}`,
    inputClass
  );

  const suffixClass = twMerge(
    'h-full w-[48px] flex items-center justify-center bg-[#EEF2FB]',
    isLightForm && 'bg-input-100-bg-default',
    isFocus && 'bg-surface-100-bg',
    hasError && 'bg-input-200-bg-critical'
  );

  function handleChange(e) {
    props.onChange(e.target.value);
  }

  function handleKeyDown(e) {
    e.keyCode === 13 && props?.onPressEnter?.();
  }

  const handleBlur = e => {
    props.onBlur?.(e.target.value);
    setIsFocus(false);
  };

  const handleFocus = e => {
    props.onFocus?.(e.target.value);
    setIsFocus(true);
  };

  useEffect(() => {
    props?.autoFocus && inputEl?.current?.focus();
  }, [props?.autoFocus]);

  return (
    <label htmlFor={id} className={outerStyles}>
      <div className={twMerge('flex-1', styles.inputContainer, isLightForm && styles.lightFormInputContainer)}>
        <span className={labelStyles}>{props.label}</span>
        <input
          ref={inputEl}
          id={id}
          value={props.value || ''}
          className={inputStyles}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          type={props?.type}
          max={props?.max}
          autoComplete="new-password"
          maxLength={props.maxLength}
          spellCheck={false}
        />
      </div>
      {!!props.suffix && <div className={suffixClass}>{props.suffix}</div>}
    </label>
  );
}
